import React from 'react';
import type BugReport from '../Models/BugReportModel';

export type BugReportContextProps = {
    bugReports: BugReport[],
    setBugReports: (bugReports: BugReport[]) => void,
    addBugReport: (bugReport: BugReport) => void,
};

const BugReportContext: React.Context<BugReportContextProps> = React.createContext<BugReportContextProps>({
    bugReports: [],
    setBugReports: () => {},
    addBugReport: () => {},
});

export default BugReportContext;